import { useSelector } from 'react-redux'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useOfferedRecipes } from 'hooks/menu-recipes/useOfferedRecipes'
import { Recipe, RecipeCoreId } from 'reducers/menu-recipes/recipes'
import { locationQuery } from 'selectors/routing'

/**
 * @deprecated This hook is deprecated and will be removed after the refactor of addRecipe logic.
 * Please use `useIsRecipeInStock` instead for checking stock status.
 * @see useIsRecipeInStock
 */
export const useInStockRecipeCoreIds = (): Set<RecipeCoreId> => {
  const offeredRecipes = Object.values(useOfferedRecipes())
  const availableRecipes = offeredRecipes
    .filter((recipe: Recipe) => recipe.isAvailable)
    .map((recipe: Recipe) => recipe.coreId)

  const { basketRecipes } = useBasketRecipes()
  const basketRecipeIds = basketRecipes.map((basketRecipe) => basketRecipe.coreId)

  const query = useSelector(locationQuery)
  const isAdmin = query && query['preview[menu_id]']

  const allRecipeCoreIds = offeredRecipes.map((recipe: Recipe) => recipe.coreId)

  const inStockRecipeCoreIds = isAdmin
    ? allRecipeCoreIds
    : [...availableRecipes, ...basketRecipeIds]

  return new Set(inStockRecipeCoreIds)
}
